'use client';
import React, {useRef} from 'react';
import {Result} from "@/app/Result";
import data from "../../public/results.json";
import Link from "next/link";
import {getId} from "@/components/Utils";

interface HeaderProps {
}

export default function Header(props: Readonly<HeaderProps>): React.ReactElement {
    const rawData: Result = data as Result;
    const navBarRef = useRef(null)

    /**
     *
     */
    function toggleNavBar() {
        return () => {
            if (navBarRef.current) {
                const navBar = navBarRef.current as HTMLElement;
                navBar?.classList.toggle("show")
            }
        };
    }

    return (
        <nav className="navbar sticky-top bg-body-tertiary shadow-sm">
            <div className="container-fluid">
                <Link legacyBehavior href="/">
                    <a className="navbar-brand">
                        RSS-Analyzer
                    </a>
                </Link>
                <button onClick={toggleNavBar()} className="navbar-toggler" type="button" data-bs-toggle="offcanvas"
                        data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar"
                        aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div ref={navBarRef} className="offcanvas offcanvas-end" id="offcanvasNavbar"
                     aria-labelledby="offcanvasNavbarLabel">
                    <div className="offcanvas-header">
                        <Link legacyBehavior href="/">
                            <h5 onClick={toggleNavBar()} className="offcanvas-title" id="offcanvasNavbarLabel">
                                RSS-Analyzer
                            </h5>
                        </Link>
                        <button onClick={toggleNavBar()} type="button" className="btn-close" data-bs-dismiss="offcanvas"
                                aria-label="close"></button>
                    </div>

                    <div className="offcanvas-body">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                            {Object.entries(rawData.categoryCountYear)
                                .sort((a, b) => a[0].localeCompare(b[0])) // Sort categories alphabetically
                                .map(([category, subcategory], index) => {
                                    if (Object.keys(subcategory).length === 0) {
                                        return (<React.Fragment key={crypto.randomUUID()}></React.Fragment>);
                                    }
                                    return (
                                        <Link href={`/${getId(category)}`} legacyBehavior key={index}>
                                            <a className="nav-link">
                                                <li className="nav-item" onClick={toggleNavBar()}>
                                                    {category}
                                                </li>
                                            </a>
                                        </Link>
                                    );
                                })}
                        </ul>
                    </div>
                </div>
            </div>
        </nav>
    )
}
